import { Modal } from 'semantic-ui-react';
export default Modal;